import { calendarFormat, calendarDateKey } from './calendarTime';

export const appointmentMessage = event => {
  const date = value =>
    calendarFormat(value, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  const time = value =>
    calendarFormat(value, { hour: '2-digit', minute: '2-digit' });
  const lines = [`📅 ${event.title}`, `Data: ${date(event.starts_at)}`];
  if (
    event.ends_at &&
    calendarDateKey(event.starts_at) !== calendarDateKey(event.ends_at)
  )
    lines.push(`Até: ${date(event.ends_at)}`);
  lines.push(
    event.all_day
      ? 'Dia inteiro'
      : `Horário: ${time(event.starts_at)}${event.ends_at ? ` às ${time(event.ends_at)}` : ''} (Brasília)`
  );
  if (event.location) lines.push(`Local: ${event.location}`);
  if (event.metadata?.google_meet_link)
    lines.push(`Google Meet: ${event.metadata.google_meet_link}`);
  return lines.join('\n');
};
